export default __webpack_public_path__ + "static/media/CivilEng_Icon-04.62994c6e.png";